import { Helper } from '../Helper';
export class UnwrapHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitPushInt(node, 1);
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=UnwrapHelper.js.map
